<template>
    <div id="qrCode" style="text-align: center;">
      <div id='code'></div>
      <canvas :id="id"></canvas>
    </div>
</template>
<style></style>
<script>
import QRCode from 'qrcode'
export default{
  props: ["id"],
  data(){
      return {
        codes:''
      }
  },
  methods: {
    useqrcode(url){
      var canvas = document.getElementById(this.id)
      QRCode.toCanvas(canvas, url, function (error) {
        if (error) console.error(error)
        console.log('QRCode success!');
      })
    }
  },
};
</script>